import { render, staticRenderFns } from "./kgdiag.vue?vue&type=template&id=53e5c310&scoped=true&"
import script from "./kgdiag.vue?vue&type=script&lang=js&"
export * from "./kgdiag.vue?vue&type=script&lang=js&"
import style0 from "./kgdiag.vue?vue&type=style&index=0&id=53e5c310&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5c310",
  null
  
)

export default component.exports